/***************/
/**  IMPORTS  **/
/***************/
import Modal from "react-bootstrap/Modal";
import Cookies from "universal-cookie";
import toast from 'react-hot-toast';

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../amplifyconfiguration.json';
import { post, del } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { NotRow, Not1Row, DeleteButton } from "../styles/NotificationOverlayStyles";

/**
 * This function is responsible for creating the Notifications modal component
 * @returns A notification modal
 */
const NotificationsOverlay = (data) => {
    
    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const email = localStorage.getItem("EMAIL");

    Amplify.configure(amplifyconfig);

    /**  HANDLES CLICKING ON NOTIFICATION  **/
    const click = async (e, id) => {
        e.stopPropagation();

        // Function to handle opening a notification
        async function openNotification(){
            try{
                // Create a POST request to open the notification
                const open = post({
                    apiName: 'NotificationAPI',
                    path: '/notification/open-notification',
                    options: {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        body: {
                            id,
                            email
                        }
                    }
                })
                data.setNotifClicked(!data.notifClicked);
            } catch (e) {
                console.log('Opening notifications POST call failed: ', e);
            }
        }
        await openNotification();
        data.notifs();
    };

    /**  HANDLES DELETING A NOTIFICATION  **/
    const clickDelete = async (e, id) => {
        e.stopPropagation();
        // Function to handle deleting a notification
        async function deleteNotification(){
            try{
                // Construct the URL with query parameters
                const url = `/notification/delete-notification?id=${id}&email=${encodeURIComponent(email)}`;
    
                // Create a DELETE request with query parameters
                const deleteNotif = del({
                    apiName: 'NotificationAPI',
                    path: url,
                    options: {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                });
    
                const { body } = await deleteNotif.response;
                const res = await body.json();
                console.log('Deleting notification DELETE call succeeded', res);
                data.setNotifDelete(!data.notifDelete);
                // Send success notification for manual update
                toast.success(`You have successfully deleted the notification`, {
                    position: 'top-center',
                    duration: 5000,
                });
            } catch (e) {
                console.log('Deleting notification DELETE call failed: ', e);
            }
        }
        await deleteNotification();
        data.notifs();
    };
    

    if (data.data) {
        
        return (
            <>
                <Modal.Header closeButton> Notifications</Modal.Header>
                <Modal.Body>
                    { data.data.length > 0 ? 
                        data.data.map(((item) => {
                            const message = item.message;
                            const opened = item.opened;
                            const id = item._id;
                                return (
                                        <div 
                                            key={item._id}
                                            onClick={(e) => click(e, id)}
                                            style={{display: "table", cursor: "pointer"}}>
                                                {opened ? (
                                                    <Not1Row>
                                                    <div style={{display: "table-cell", padding: "10px"}}>
                                                    {message}
                                                    <div style={{fontSize: '10px', textAlign: 'right', fontStyle: 'italic', paddingTop: 5}}>
                                                        {item.date}
                                                    </div>
                                                    </div>
                                                    <DeleteButton
                                                        onClick={(e) => clickDelete(e, id)}>
                                                            X
                                                    </DeleteButton>
                                                    </Not1Row>
                                                ) : (
                                                    <NotRow style={{display: "table-row"}}>
                                                    <div style={{display: "table-cell", padding: "10px"}}>
                                                    {message}
                                                    <div style={{fontSize: '10px', textAlign: 'right', fontStyle: 'italic', paddingTop: 5}}>
                                                        {item.date}
                                                    </div>
                                                    </div>
                                                    <DeleteButton
                                                        onClick={(e) => clickDelete(e, id)}>
                                                            X
                                                    </DeleteButton>
                                                    </NotRow>
                                                )}
                                        </div>
                                        )
                        }))
                    :   <div style={{textAlign: "center"}}>
                            No new notifications
                        </div>
                    }
                </Modal.Body>
            </>
         )
    }
}

export default NotificationsOverlay;
